/* eslint-disable no-prototype-builtins */
import $ from 'zepto';
import { getXoom } from '../xoom';
import initMain from '../form/main';
/**
 * @todo Remove this file on phase 2 of siteContent assets migration
 */

const init = () => {
  const xoom = getXoom();
  const uiObjects = {};
  const scopedUiObjects = {};
  const hideOnBodyClickMap = {};
  let updateTimeout;
  const widgets = {};
  let savedWindowWidth;

  if (!xoom.form || !xoom.form.init) {
    initMain();
  }

  function register(id, uiObject, scope, hideOnBodyClick) {
    // all ui objects
    uiObjects[id] = uiObject;

    // ui objects by scope (useful when dealing with objects in xoom-dialog)
    if (scope) {
      if (!scopedUiObjects[scope]) {
        scopedUiObjects[scope] = {};
      }
      scopedUiObjects[scope][id] = uiObject;
    }

    // create a map of objects that are to be hidden when the user clicks on the body
    if (hideOnBodyClick === true) {
      hideOnBodyClickMap[id] = uiObject;
    }
  }

  function unregister(id, scope) {
    delete uiObjects[id];
    delete hideOnBodyClickMap[id];

    if (scopedUiObjects[scope]) {
      delete scopedUiObjects[scope][id];
    }
  }

  function iterateOverItems(callbackName, items) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in (items || uiObjects)) {
      if (uiObjects.hasOwnProperty(key)) {
        const item = uiObjects[key];
        if (item && item[callbackName]) {
          item[callbackName]();
        }
      }
    }
  }

  function doForItemsInScope(scope, callbackName) {
    const items = scopedUiObjects[scope];
    if (scopedUiObjects[scope]) {
      iterateOverItems(callbackName, items);
    }
  }

  function update() {
    if (updateTimeout) {
      clearTimeout(updateTimeout);
    }

    updateTimeout = setTimeout(() => {
      /* Below width check corrects for iOS 6+ bug where scrolling triggers a window resize event */
      const currentWindowWidth = $(window).width();
      if (savedWindowWidth !== currentWindowWidth) {
        iterateOverItems('update');
        savedWindowWidth = currentWindowWidth;
      }
    }, 200);
  }

  function hide() {
    iterateOverItems('hide');
  }

  function destroyItemsInScope(scope) {
    doForItemsInScope(scope, 'destroy');
  }
  function hideItemsInScope(scope) {
    doForItemsInScope(scope, 'hide');
  }

  function hideItemsOnBodyClick() {
    iterateOverItems('hide', hideOnBodyClickMap);
  }

  function registerWidget(name, widget, ignoreIfExists) {
    if (!(ignoreIfExists && widgets[name])) {
      widgets[name] = widget;
    }
  }

  function initializeWidgets(contextSelector, callback) {
    let callbacksFired = 0;
    let widgetsCount = 0;

    function initializeCallback() {
      callbacksFired += 1;

      // If this is the last widgetCallback, fire the requested callback, if there was one
      if (callbacksFired === widgetsCount) {
        if (callback) {
          callback();
        }
      }
    }

    // get the count of the existing widgets
    // we will use this count to make the callback fire only once when all widgets are initialized
    // eslint-disable-next-line no-restricted-syntax
    for (const obj in widgets) {
      if (widgets.hasOwnProperty(obj)) {
        widgetsCount += 1;
      }
    }

    if (widgetsCount > 0) {
      // loop through all of the registered widgets and initialize them
      // if a callback was specified, only fire the callback once all widgets are initialized
      // eslint-disable-next-line no-restricted-syntax
      for (const widgetObject in widgets) {
        if (widgets.hasOwnProperty(widgetObject)) {
          const widget = widgets[widgetObject];
          if (widget.initializeWidget) {
            // assumption:  all widgets have a initializeWidget method that has a callback as the second argument
            // if the widget doesn't support this callback, we will never fire the specified callback
            widget.initializeWidget(contextSelector, initializeCallback);
          }
        }
      }
    } else if (callback) {
      callback();
    }

    // do any form stuff
    xoom.form.init(contextSelector);
  }

  $(document)
    .bind('click', hideItemsOnBodyClick)
    .ready(() => {
      savedWindowWidth = $(window).width();
    });

  $(window).bind('resize', update);

  /*
  Register Auto Created Widgets  v1.0
  Register widgets/modules that are created automatically based on a the presence of a class or rel on a DOM element
  This code will register a bootloader for these widgets.  If the widgets need to be loaded, it will load
  the full widget/module JavaScript files.
  This is only compatible with xoom modules which have been coded to support "initializeWidget" method
  */
  function registerAutoWidgets(name, selectorsToMatch) {
    registerWidget(name, (() => {
      function initializeWidget(context, callback) {
        if ($(selectorsToMatch).length) {
          xoom.module.require(name, (module) => {
            module.initializeWidget(context, callback);
          });
        } else if (callback) {
          callback();
        }
      }

      $(document).ready(() => {
        if ($(selectorsToMatch).length) {
          xoom.module.require(name, (module) => {
            module.initializeWidget();
          });
        }
      });

      return {
        initializeWidget,
      };
    })(), 1);
  }

  if (xoom.settings && xoom.settings.jsSupported) { // do not run this on crappy old browsers that we don't support
    if (!xoom.settings.isMobile) {
      registerAutoWidgets('xoom.ui.CustomPulldown', 'select.custom-pulldown, select.language-pulldown');
    }
    registerAutoWidgets('xoom.ui.CustomRadio', 'input.custom-radio');
    registerAutoWidgets('xoom.form.PhoneMask', 'input.mask-phone');
    registerAutoWidgets('xoom.form.Placeholder', 'input[placeholder]');
  }

  xoom.UIManager = {
    register,
    update,
    hide,
    unregister,
    destroyItemsInScope,
    hideItemsInScope,
    widgets: {
      register: registerWidget,
      initialize: initializeWidgets,
    },
  };
};

export default init;
